import ComicCard from "@/components/base/ComicCard";
import { getLatestComics } from "@/mocks/comics";

export default function LatestUpdates() {
  const latest = getLatestComics();

  return (
    <section className="py-16 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-1 h-5 rounded-full bg-secondary-500" />
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
              最新更新
            </h2>
            <span className="inline-flex items-center gap-1 text-xs text-secondary-400">
              <span className="w-1.5 h-1.5 rounded-full bg-secondary-500 animate-pulse" />
              实时更新中
            </span>
          </div>
          <p className="text-foreground-500 text-sm">
            最新更新的韩漫章节，精彩内容第一时间送达
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {latest.map((comic) => (
            <div key={comic.id} className="flex justify-center">
              <ComicCard comic={comic} size="medium" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}